import { CheckCircle2, Circle, Clock, AlertCircle } from 'lucide-react';

export default function GoalStatusSnapshot({ total, completed, active, blocked }) {
  const cards = [
    {
      label: 'Total',
      value: total,
      icon: Circle,
      color: 'text-text-secondary',
      bg: 'bg-surface-hover',
    },
    {
      label: 'Done',
      value: completed,
      icon: CheckCircle2,
      color: 'text-green-500',
      bg: 'bg-green-500/10',
    },
    {
      label: 'Active',
      value: active,
      icon: Clock,
      color: 'text-accent',
      bg: 'bg-accent/10',
    },
    {
      label: 'Blocked',
      value: blocked,
      icon: AlertCircle,
      color: 'text-amber-500',
      bg: 'bg-amber-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-3 mb-6">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.label}
            className={`${card.bg} rounded-xl p-3 text-center transition-all hover:scale-[1.02]`}
          >
            <div className="flex items-center justify-center mb-1">
              <Icon size={16} className={card.color} />
            </div>
            <div className={`text-2xl font-bold ${card.color}`}>
              {card.value}
            </div>
            <div className="text-[10px] text-text-tertiary uppercase tracking-wide">
              {card.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
